import {
  changeInvitationStatus,
  ChangeInvitationStatusParams,
} from '@/domain/external-invitation/actions/change-invitation-status.action';
import { ExternalInvitation } from '@/domain/external-invitation/entities/external-invitation.entity';
import { createAppAsyncThunk } from '@/domain/store.thunk';

import { getExternalInvitationSurveys } from './get-external-invitation-surveys.action';
import { getSurveysResults } from './get-surveys-results.action';

type Params = {
  invitation: ExternalInvitation;
};

export const deleteExternalInvitationSurvey = createAppAsyncThunk(
  'externalInvitationSurvey/deleteExternalInvitationSurvey',
  async (params: Params, { dispatch }) => {
    const arg: ChangeInvitationStatusParams = {
      invitation: params.invitation,
      status: 'ARCHIVED',
    };
    await dispatch(changeInvitationStatus(arg));
    await dispatch(getExternalInvitationSurveys());
    await dispatch(getSurveysResults());
  },
);
